import { render } from "./send-confirmation.vue?vue&type=template&id=4914e2c8&scoped=true"
import script from "./send-confirmation.vue?vue&type=script&lang=js"
export * from "./send-confirmation.vue?vue&type=script&lang=js"

import "./send-confirmation.vue?vue&type=style&index=0&id=4914e2c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4914e2c8"]])

export default __exports__